<template>
    <div class="bad-browser">
        <div class="container">
            <div class="title">Ваш браузер устарел или не поддерживается</div>
            <div class="message">
                Браузер может не поддерживать некоторые функции приложения, что повлияет на работоспособность
                портала.<br>
                Чтобы воспользоваться всеми возможностями, необходимо обновить браузер.
            </div>
            <div class="browser-list">
                <div class="item chrome">
                    <div class="icon-holder">
                        <div class="icon"></div>
                    </div>
                    <div class="name">Google Chrome</div>
                    <div class="version">v.111<br> и выше</div>
                </div>
                <div class="item edge">
                    <div class="icon-holder">
                        <div class="icon"></div>
                    </div>
                    <div class="name">Microsoft Edge</div>
                    <div class="version">v.125<br> и выше</div>
                </div>
                <div class="item firefox">
                    <div class="icon-holder">
                        <div class="icon"></div>
                    </div>
                    <div class="name">Mozilla Firefox</div>
                    <div class="version">v.100<br> и выше</div>
                </div>
                <div class="item safari">
                    <div class="icon-holder">
                        <div class="icon"></div>
                    </div>
                    <div class="name">Safari</div>
                    <div class="version">v.17<br> и выше</div>
                </div>
                <div class="item yandex">
                    <div class="icon-holder">
                        <div class="icon"></div>
                    </div>
                    <div class="name">Yandex Browser</div>
                    <div class="version">v.23<br> и выше</div>
                </div>
                <div class="item opera">
                    <div class="icon-holder">
                        <div class="icon"></div>
                    </div>
                    <div class="name">Opera</div>
                    <div class="version">v.87<br> и выше</div>
                </div>
            </div>
            <div class="actions">
                <input class="primary" type="button" value="Продолжить без обновления" @click="next" />
            </div>
            <div class="message">
                Если вы используете компьютер внутри корпоративной сети ПАО Ростелеком,
                обновить версию браузера можно самостоятельно, либо через портал
                <a class="accent" href="https://helpme.rt.ru/tickets/create/otrs1/1671">Helpme</a>,
                услуга: «Техническое обслуживание компьютеров, ноутбуков, планшетов».
                В ином случае обновить версию браузера можно самостоятельно, либо обратившись к своему системному
                администратору.
            </div>
        </div>
    </div>
</template>

<script>
import { isBrowserSupport } from '@/common/browser.support.js';
import { badBrowserLocalSet } from '@/pages/bad_browser/common/config.js';

export default {
    name: 'BadBrowser',
    computed: {
    },
    created() {
        const redirect = this.$route.query.redirect ?? '/';
        if (isBrowserSupport()) {
            this.$router.push(redirect);
        }
    },
    methods: {
        next() {
            badBrowserLocalSet(true);
            const redirect = this.$route.query.redirect ?? '/';
            this.$router.push(redirect);
        },
    },
};
</script>

<style lang="scss" scoped>
@import '~@dsee/mixins';

.bad-browser {
    min-height: 100vh;
    background: #FFFFFF url('../common/icons/bg.png') no-repeat;
    background-position: right top;
    background-size: contain;

    .container {
        display: flex;
        flex-flow: column;
        margin: 0 10vw;
        padding-top: 20vh;
        padding-bottom: 10vh;
        box-sizing: border-box;
    }

    .title {
        font-weight: 700;
        font-size: 32px;
        line-height: 44px;
        margin-bottom: 32px;
    }

    .browser-list {
        display: flex;
        flex-flow: row wrap;
        gap: 20px;
        margin: 32px 0;

        .item {
            display: flex;
            flex-flow: column nowrap;
            align-items: center;
            border: 1px solid rgba(16, 24, 40, 0.1);
            border-radius: 12px;
            padding: 20px 28px;
            height: 160px;
            width: 148px;
            box-sizing: border-box;

            .icon-holder {
                padding: 8px;
                background: rgba(16, 24, 40, 0.05);
                border-radius: 10px;
                width: 56px;
                height: 56px;
                box-sizing: border-box;

                .icon {
                    @include icon(40px, 40px);
                    cursor: default;
                }
            }

            .name {
                font-weight: 500;
                font-size: 12px;
                line-height: 16px;
                margin-top: 12px;
                margin-bottom: 4px;
            }

            .version {
                font-size: 12px;
                line-height: 16px;
                text-align: center;
                color: rgba(16, 24, 40, 0.5);
            }

            &.chrome .icon {
                background-image: url('../common/icons/chrome.png');
            }

            &.edge .icon {
                background-image: url('../common/icons/edge.png');
            }

            &.firefox .icon {
                background-image: url('../common/icons/firefox.png');
            }

            &.safari .icon {
                background-image: url('../common/icons/safari.png');
            }

            &.yandex .icon {
                background-image: url('../common/icons/yandex.png');
            }

            &.opera .icon {
                background-image: url('../common/icons/opera.png');
            }
        }
    }

    .actions {
        margin-bottom: 20px;
    }

    .message {
        font-size: 16px;
        line-height: 22px;
        max-width: 900px;

        &:last-child {
            margin-top: auto;
        }
    }
}
</style>
